<template>
    <option value="ranch">Ranch</option>
    <option value="facility">Facility</option>
    <option value="site">Site</option>
    <option value="lab">Lab</option>
    <option value="farm">Farm</option>
    <option value="internal">Internal</option>
</template>
